import { PublicLayout } from "../../components/public-layout.js";

export function TermsPage() {
  return (
    <PublicLayout hideFooter={false}>
      <div className="legal-page">
        <h1>Terms of Service</h1>

        <p>
          <strong>Last updated:</strong> March 2025
        </p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using AccessiMonitor ("Service"), you accept and
            agree to be bound by the terms and provision of this agreement. If
            you do not agree to abide by the above, please do not use this
            service.
          </p>
        </section>

        <section>
          <h2>2. Use License</h2>
          <p>
            Permission is granted to temporarily download one copy of the
            materials (information, software, and graphics) on AccessiMonitor
            for personal, non-commercial transitory viewing only. This is the
            grant of a license, not a transfer of title, and under this license
            you may not:
          </p>
          <ul>
            <li>Modify or copy the materials</li>
            <li>
              Use the materials for any commercial purpose or for any public
              display
            </li>
            <li>
              Attempt to reverse engineer any software or code on the Service
            </li>
            <li>
              Remove any copyright or other proprietary notations from the
              materials
            </li>
            <li>
              Transmit the materials to anyone else or "mirror" the materials on
              any server
            </li>
            <li>
              Access materials on AccessiMonitor for any purpose other than your
              own automated accessibility monitoring
            </li>
          </ul>
        </section>

        <section>
          <h2>3. Disclaimer</h2>
          <p>
            The materials on AccessiMonitor are provided "as is" without
            warranties of any kind, express or implied. AccessiMonitor disclaims
            all warranties including, without limitation:
          </p>
          <ul>
            <li>
              Warranties of merchantability or fitness for a particular purpose
            </li>
            <li>Completeness or accuracy of scan findings</li>
            <li>That the Service will be uninterrupted or error-free</li>
            <li>That vulnerabilities or defects will be corrected</li>
          </ul>
          <p>
            <strong>Note:</strong> Automated accessibility scanning finds many
            issues but not all. Manual accessibility review and user testing are
            essential.
          </p>
        </section>

        <section>
          <h2>4. Limitations of Liability</h2>
          <p>
            In no event shall AccessiMonitor or its suppliers be liable for any
            damages (including, without limitation, damages for loss of data or
            profit, or due to business interruption) arising out of the use or
            inability to use the materials on AccessiMonitor.
          </p>
        </section>

        <section>
          <h2>5. Accuracy of Materials</h2>
          <p>
            The materials appearing on AccessiMonitor could include technical,
            typographical, or photographic errors. AccessiMonitor does not
            warrant that any of the materials on the Service are accurate,
            complete, or current. AccessiMonitor may make changes to the
            materials contained on the Service at any time without notice.
          </p>
        </section>

        <section>
          <h2>6. Materials Disclaimer</h2>
          <p>
            The materials on AccessiMonitor are provided "as is". AccessiMonitor
            makes no warranties, expressed or implied, and hereby disclaims and
            negates all other warranties including, without limitation, implied
            warranties of merchantability, fitness for a particular purpose, or
            non-infringement of intellectual property or other violation of
            rights.
          </p>
        </section>

        <section>
          <h2>7. Limitations</h2>
          <p>
            The materials on AccessiMonitor and any related materials are
            provided with the understanding that AccessiMonitor is not herein
            engaged in rendering legal, compliance, or professional advice. For
            matters requiring legal judgment, consult with qualified legal
            counsel.
          </p>
        </section>

        <section>
          <h2>8. Governing Law</h2>
          <p>
            These terms and conditions are governed by and construed in
            accordance with the laws of the jurisdiction where AccessiMonitor is
            located, and you irrevocably submit to the exclusive jurisdiction of
            the courts in that location.
          </p>
        </section>

        <section>
          <h2>9. Your Obligations</h2>
          <p>You agree to:</p>
          <ul>
            <li>Not use the Service for any illegal or unauthorized purpose</li>
            <li>Not transmit viruses, malware, or harmful code</li>
            <li>Not attempt to gain unauthorized access to the Service</li>
            <li>Not violate any applicable laws or regulations</li>
            <li>Respect the intellectual property rights of others</li>
            <li>
              Comply with your obligations to provide accurate website
              information
            </li>
          </ul>
        </section>

        <section>
          <h2>10. Intellectual Property Rights</h2>
          <p>
            The Service and its entire contents, features, and functionality
            (including but not limited to all information, software, text,
            displays, images, video, and audio) are owned by AccessiMonitor and
            its licensors. Scanning findings that you receive are provided for
            your use and may be shared with your team, but you may not
            redistribute the scanning methodology or tools.
          </p>
        </section>

        <section>
          <h2>11. User Content</h2>
          <p>
            You retain ownership of any content you provide to the Service. By
            providing content, you grant AccessiMonitor a license to use it for
            providing the Service. You represent and warrant that you have the
            right to provide such content.
          </p>
        </section>

        <section>
          <h2>12. Termination</h2>
          <p>
            AccessiMonitor may terminate or suspend your access to the Service
            at any time, with or without cause, and with or without
            notice.Causes for termination include:
          </p>
          <ul>
            <li>Breach of these Terms</li>
            <li>Illegal activity or abuse</li>
            <li>Non-payment of fees (for paid accounts)</li>
            <li>Inactivity for extended periods</li>
          </ul>
        </section>

        <section>
          <h2>13. Changes to Terms</h2>
          <p>
            AccessiMonitor reserves the right to modify or revise these terms at
            any time. Your continued use of the Service following the posting of
            revised terms means that you accept and agree to the changes.
          </p>
        </section>

        <section>
          <h2>14. Contact Us</h2>
          <p>
            If you have questions about these Terms, contact us at:
            <br />
            Email: legal@accessimonitor.app
          </p>
        </section>
      </div>
    </PublicLayout>
  );
}
